var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmoking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.5572,
    height: 63.5572,
    rx: 15.8893,
    fill: "#2EC8EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9023 31.7441C40.9023 32.2134 41.2827 32.5937 41.752 32.5937C42.2212 32.5937 42.6016 32.2134 42.6016 31.7441C42.6016 27.9209 40.6155 26.4314 38.8633 25.1172C37.2221 23.8863 35.8047 22.8232 35.8047 19.8496C35.8047 19.3804 35.4243 19 34.9551 19C34.4859 19 34.1055 19.3804 34.1055 19.8496C34.1055 23.6729 36.0915 25.1624 37.8438 26.4766C39.485 27.7075 40.9023 28.7705 40.9023 31.7441ZM42.6016 19.8496C42.6016 19.3804 42.2212 19 41.752 19C41.2827 19 40.9023 19.3804 40.9023 19.8496C40.9023 23.5053 41.8809 24.9732 42.7442 26.2681C43.5447 27.4688 44.3008 28.603 44.3008 31.7441C44.3008 32.2134 44.6812 32.5937 45.1504 32.5937C45.6196 32.5937 46 32.2134 46 31.7441C46 28.0884 45.0215 26.6206 44.1581 25.3256C43.3577 24.1249 42.6016 22.9908 42.6016 19.8496ZM45.1504 34.293H17.8496C17.3804 34.293 17 34.6734 17 35.1426V40.2402C17 40.7094 17.3804 41.0898 17.8496 41.0898H45.1504C45.6196 41.0898 46 40.7094 46 40.2402V35.1426C46 34.6734 45.6196 34.293 45.1504 34.293ZM40.9023 35.9922V39.3906H28.9512V35.9922H40.9023ZM18.6992 35.9922H27.252V39.3906H18.6992V35.9922ZM44.3008 39.3906H42.6016V35.9922H44.3008V39.3906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoking);
export default __webpack_public_path__ + "static/media/smoking.45c7a511eb94209fdc657f66836e1b4b.svg";
export { ForwardRef as ReactComponent };